// useTenantLoginPolicy — one tenant's login policy, for a signed-in screen.
//
// The profile pages ("How you sign in") colour a "Not verified" pill red only
// where the tenant's policy demands a code for that channel (owner, 1 Oct
// 2026); elsewhere it is a neutral grey. They all need the same one answer —
// GET /tenants/public?tenantId=… → loginPolicy — so it is fetched here.
// Until it arrives (or when it cannot be read) the platform DEFAULT_POLICY
// stands, exactly as on every other policy-shaped screen.

import { useEffect, useState } from 'react';
import createAuthedAxios from './useAxiosAuth';
import baseURL from '../utils/baseURL';
import { policyFor } from '../utils/loginPolicy';

export default function useTenantLoginPolicy(tenantId) {
    const [tenants, setTenants] = useState([]);
    useEffect(() => {
        if (!tenantId) return undefined;
        let alive = true;
        Promise.resolve()
            .then(() => createAuthedAxios().get(`${baseURL}/tenants/public`, { params: { tenantId } }))
            .then((res) => { if (alive) setTenants(res?.data?.tenants || []); })
            .catch(() => { if (alive) setTenants([]); });
        return () => { alive = false; };
    }, [tenantId]);
    return policyFor(tenants, tenantId || '');
}
